import { Linkedin, Instagram, Mail } from "lucide-react";
import { useContent } from "@/context/ContentContext";

export default function Socials() {
    const { contact } = useContent();
    const ITEMS = [
        { icon: Linkedin, href: contact.linkedin_url, label: "LinkedIn", testid: "social-linkedin" },
        { icon: Instagram, href: contact.instagram_url, label: "Instagram", testid: "social-instagram" },
        { icon: Mail, href: `mailto:${contact.email}`, label: "Email", testid: "social-email" },
    ];

    return (
        <div className="flex items-center gap-3" data-testid="social-links">
            {ITEMS.map(({ icon: Icon, href, label, testid }) => (
                <a
                    key={label}
                    href={href}
                    target="_blank"
                    rel="noreferrer"
                    aria-label={label}
                    data-testid={testid}
                    className="grid place-items-center h-10 w-10 rounded-full border border-current/30 transition-colors duration-300 hover:bg-sage hover:text-ink hover:border-sage"
                >
                    <Icon className="h-4 w-4" />
                </a>
            ))}
        </div>
    );
}
